import { useEffect, useState } from 'react'
import { Keyboard, KeyboardEvent, Platform } from 'react-native'

export default function useKeyboardState() {
  const [keyboardHeight, setKeyboardHeight] = useState(0)
  const [isKeyboardVisible, setKeyboardVisible] = useState(false)

  useEffect(() => {
    const showEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow'
    const hideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide'

    const onKeyboardShow = (e: KeyboardEvent) => {
      setKeyboardHeight(e.endCoordinates.height)
      setKeyboardVisible(true)
    }

    const onKeyboardHide = () => {
      setKeyboardHeight(0)
      setKeyboardVisible(false)
    }

    const showSub = Keyboard.addListener(showEvent, onKeyboardShow)
    const hideSub = Keyboard.addListener(hideEvent, onKeyboardHide)

    return () => {
      showSub.remove()
      hideSub.remove()
    }
  }, [])

  return { keyboardHeight, isKeyboardVisible }
}
